type Props = { html: string };

export const HTML = ({ html }: Props) => {
    return <div style={{ display: 'contents' }} dangerouslySetInnerHTML={{ __html: html }}></div>;
};
